var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag ? _vm.tag : _vm.tagByTypo[_vm.typo],{tag:"Component",staticClass:"WText",class:_vm.typoClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }